'use client';

import React from 'react';
import { BottomBar } from '@/widgets/BottomBar';
import { useBottomBarVisibility } from '@/shared/hooks/dom/useBottomBarVisibility';
import { BookingButtons } from '../booking/BookingButtons';
import type { IBookingDoctorData } from '@/entities/booking/model/types';
import type { IDoctorDetails } from '@/entities/doctor/model/types';
import type { IMedcenter } from '@/entities/medcenter/model/types';
interface Props {
  medcenters: IMedcenter[];
  doctor: IDoctorDetails;
  bookingData: IBookingDoctorData[];
  bookingButtonsSelector?: string;
  debounceMs?: number;
}
export const DoctorBottomBar: React.FC<Props> = ({
  medcenters,
  bookingData,
  doctor,
  bookingButtonsSelector = '[data-booking-buttons]',
  debounceMs = 150
}) => {
  const {
    shouldShowBottomBar
  } = useBottomBarVisibility({
    triggerSelector: bookingButtonsSelector,
    debounceMs
  });
  return <BottomBar variant="glassmorphism" align="flex" isVisible={shouldShowBottomBar} data-sentry-element="BottomBar" data-sentry-component="DoctorBottomBar" data-sentry-source-file="DoctorBottomBar.tsx">
      <BookingButtons bookingData={bookingData} medcenters={medcenters} doctor={doctor} isBottomBar data-sentry-element="BookingButtons" data-sentry-source-file="DoctorBottomBar.tsx" />
    </BottomBar>;
};